import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { haalSignalen, type SignalenClient } from './data/signalen';

const client = supabase as unknown as SignalenClient & { from(t: string): any };

export function useSignalen() {
  return useQuery({ queryKey: ['projectlijst', 'signalen'], queryFn: () => haalSignalen(client), staleTime: 60_000 });
}

export interface KortProject {
  id: string;
  name: string;
  project_number: string | null;
  stage: string | null;
}

/** Alle projecten, alleen wat de projectwisselaar nodig heeft; nieuwste nummer eerst. */
export function useProjectenKort({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    enabled,
    queryKey: ['projectlijst', 'kort'],
    queryFn: async (): Promise<KortProject[]> => {
      const { data, error } = await client
        .from('projects')
        .select('id, name, project_number, stage')
        .is('deleted_at', null)
        .order('project_number', { ascending: false, nullsFirst: false });
      if (error) throw error;
      return data ?? [];
    },
    staleTime: 5 * 60_000,
  });
}
